module.exports = __webpack_public_path__ + "img/prize-sty-dark.898c0327.png";